import { isError } from 'flux-standard-action';
import { payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';
import { LAUNCH_STATE } from '../constants';

const successMutationGenerator = (payload) => {
  const mutation = {
    launchState: { $set: payload },
    error: { $set: null },
  };
  switch (payload) {
    case LAUNCH_STATE.UI_LOADED:
      mutation.uiLoaded = { $set: true };
      break;
    case LAUNCH_STATE.VIDEO_LOADED:
      mutation.videoLoaded = { $set: true };
      break;
    case LAUNCH_STATE.APP_LOADED:
      mutation.appLoaded = { $set: true };
      break;
    default:
      break;
  }
  return mutation;
};

const errorMutationGenerator = (error) => ({
  launchState: { $set: null },
  error: { $set: error },
});

const stateMutationGenerator = (action) =>
  isError(action) ? errorMutationGenerator : successMutationGenerator;

export const applicationLaunchStateReducer = (currentState, action) =>
  updateState(currentState, stateMutationGenerator(action)(payloadExtractor(action)));
